export default __webpack_public_path__ + "media/music/1e5a1f894f4dc4b3f5fae7282a348c83.mp3";